"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabContext_exports = {};
__export(TabContext_exports, {
  TabContext: () => TabContext,
  TabTriggerMapContext: () => TabTriggerMapContext,
  TabsDescriptorsContext: () => TabsDescriptorsContext,
  TabsNavigatorContext: () => TabsNavigatorContext,
  TabsStateContext: () => TabsStateContext
});
module.exports = __toCommonJS(TabContext_exports);
var import_react = require("react");
var TabContext = /* @__PURE__ */ (0, import_react.createContext)({});
var TabTriggerMapContext = /* @__PURE__ */ (0, import_react.createContext)({});
var TabsDescriptorsContext = /* @__PURE__ */ (0, import_react.createContext)({});
var TabsNavigatorContext = /* @__PURE__ */ (0, import_react.createContext)(null);
var TabsStateContext = /* @__PURE__ */ (0, import_react.createContext)({
  type: "tab",
  preloadedRouteKeys: [],
  history: [],
  index: -1,
  key: "",
  stale: false,
  routeNames: [],
  routes: []
});
//# sourceMappingURL=TabContext.js.map
